import React, { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import CONSTS from '../config/constants';

const SentryReport = () => {
  //Sentry tracking for https://tramitta.cl/
  const sendReport = () => {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY,
      integrations: [new Integrations.BrowserTracing()],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    });
  };

  useEffect(() => {
    if (process.env.REACT_APP_ENV === CONSTS.ENV.PROD) {
      sendReport();
    }
  }, []);

  return (<></>);
};

export default SentryReport;